export const ObservationCategory = {
    "Weeds": 1,
    "Diseases": 2,
    "Pests": 3,
    "Other": 4,
};

export const FeatureType = {
    "Shared": 5301
}